import React from 'react';
import { useSelector } from 'react-redux';
import { Spin } from 'antd';
import { BiTimeFive } from 'react-icons/bi';
import BlockHeader from '../BlockHeader/BlockHeader';
import TimeRangeList from '../TimeRangeList/TimeRangeList';
import useRequestInvitationHours from '../../../../queries/useRequestInvitationHours';
import { selectedRequestSelector } from '../../../../reducers/acceptanceRequestToCalendarReducer';
import styles from './TimeRangeBlock.module.scss';

const TimeRangeBlock = ({ timeRange, onChange, selectedDate }) => {
  const request = useSelector(selectedRequestSelector);

  const { data: timeRanges, isFetching: isTimeRangesFetching } =
    useRequestInvitationHours(
      {
        requestId: request?.id,
        date: selectedDate?.clone()?.format('YYYY-MM-DD'),
      },
      {
        enabled: Boolean(request && selectedDate),
      }
    );

  return (
    <Spin spinning={isTimeRangesFetching}>
      <BlockHeader
        as="header"
        icon={<BiTimeFive />}
        title="Выбрать период"
        description="Начало и конец приемки"
        className={styles.header}
      />
      <TimeRangeList
        ranges={timeRanges}
        onChange={onChange}
        currentRange={timeRange}
      />
    </Spin>
  );
};

export default TimeRangeBlock;
